import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { services } from '../Services';
import './ServicesDetail.css';
import VideoWithLoader from './VideoWithLoader';

// Импорт видеофайлов
import laserVideoMP4 from '../../../assets/videos/rezka.mp4';
import laserVideoWebM from '../../../assets/videos/rezka.webm';
import bendingVideoMP4 from '../../../assets/videos/gibka.mp4';
import bendingVideoWebM from '../../../assets/videos/gibka.webm';
import svarkaVideoMP4 from '../../../assets/videos/svarka.mp4';
import svarkaVideoWebM from '../../../assets/videos/svarka.webm';
import mehObrabotkaMP4 from '../../../assets/videos/mehObrabotka.mp4';
import mehObrabotkaWebM from '../../../assets/videos/mehObrabotka.mp4';
import pokraskaMP4 from '../../../assets/videos/pokraska.mp4';
import pokraskaWebM from '../../../assets/videos/pokraska.webm';

const LASER_DESCRIPTION = [
    'Лазерная резка металла — это технология обработки металла, при которой материал разделяется с помощью мощного сфокусированного лазерного луча. Один из самых прогрессивных и инновационных методов раскроя листового металла.',
    'Лазерный раскрой заготовки производится посредством сквозного прожига листа высокоэнергичным лазерным лучом, при этом термическое воздействие на обрабатываемый материал остаётся незначительным.',
    '',
    'Наша компания оказывает услуги лазерной резки металла для частных клиентов и производственных предприятий. Мы работаем как с готовыми чертежами, так и с эскизами или PDF‑файлами.',
    'Высококвалифицированные специалисты компании готовы выполнить заказы любой сложности с максимальной точностью и в установленные сроки.',
    'Современное оборудование позволяет обрабатывать углеродистую сталь, нержавеющую сталь, алюминий, титан, медь, латунь и другие материалы с минимальными допусками и максимальной скоростью.',
    'Мы располагаем собственным складом металлопроката, что позволяет оперативно запускать производство и минимизировать сроки выполнения заказов.',
    'Если нужного материала нет на складе — мы быстро организуем поставку, чтобы не задерживать ваш проект.'
];

const GIBKA_DESCRIPTION = [
    'В нашей компании гибка интегрирована в общий цикл металлообработки — вместе с лазерной резкой, сваркой, очисткой и финишной обработкой.',
    'Это даёт возможность реализовывать проекты любой сложности с инженерной точностью и производственной надёжностью.',
    'Управляющая программа создаётся на основе CAD‑чертежей, с учётом толщины металла, радиуса гиба, угла и компенсации пружинения, что позволяет избежать ошибок и деформаций при серийном производстве.',
    '',
    'Компания ООО «Характер металла» осуществляет услуги гибки углеродистой и нержавеющей стали, алюминия, меди и латуни.',
    '',
    'КАК РАБОТАЕТ ТЕХНОЛОГИЯ ГИБКИ МЕТАЛЛА?',
    'Гибка листового металла — это способ обработки заготовки, при котором лист изменяет форму под действием усилия гидравлического листогибочного пресса. Мы используем ЧПУ‑оборудование, обеспечивающее высокую точность геометрии и повторяемость при серийных заказах.',
    '',
    'ПРИМЕНЯЕМЫЕ МЕТОДЫ ГИБКИ МЕТАЛЛА:\n',
    '· V‑образная гибка\n',
    'Классический способ, при котором лист деформируется между V‑образным пуансоном и матрицей. Обеспечивает чёткие углы и высокую повторяемость, особенно при серийном производстве.\n',
    '',
    '· Воздушная гибка\n',
    'Лист опирается на две точки матрицы, а пуансон задаёт глубину гиба. Позволяет получать разные углы с одной оснасткой, подходит для сложных форм и переменных радиусов.\n',
    '',
    '· Нижнее прессование (коиннинг)\n',
    '· Лист полностью прижимается к матрице, угол формируется по её геометрии. Метод обеспечивает максимальную точность и минимальное пружинение, используется для ответственных деталей.\n',
    '',
    '· Гибка с контролем радиуса\n',
    'Применяется при необходимости сохранить внутренний радиус без складок и трещин, особенно при работе с алюминием и нержавеющей сталью.\n',
    '',
    '· Многоступенчатая гибка\n',
    'Последовательное формирование сложной геометрии с несколькими изгибами. Используется для фасонных элементов, корпусов и нестандартных деталей.\n'
];

const WELDING_DESCRIPTION = [
    'Компания ООО «Характер металла» выполняет сварочные работы по чертежам, эскизам или 3D‑моделям. Работаем с заготовками любой формы и толщины — от точечных соединений до ответственных узлов.',
    'Используем проверенные технологии сварки, подходящие для металлоконструкций, корпусных деталей, мебели, труб и других изделий любой сложности.',
    'Выполняем сварочные работы с использованием трёх ключевых технологий: полуавтоматическая сварка, аргонодуговая (TIG) и ручная дуговая (MMA).',
    'Каждый метод подбирается под задачу: от точных швов на тонком алюминии до надёжных соединений массивных металлоконструкций.',
    'Используем современное оборудование, соблюдаем стандарты и гарантируем качество швов, устойчивость соединений и аккуратный внешний вид.',
    'ВИДЫ СВАРКИ:',
    '· ПОЛУАВТОМАТИЧЕСКАЯ СВАРКА (MIG/MAG)\n' +
    'Быстрая и универсальная технология, подходит для соединения стали. Даёт ровный сварной шов с минимальной деформацией.',
    '',
    '· АРГОНОДУГОВАЯ СВАРКА (TIG)\n' +
    'Оптимальна для тонкостенных деталей, цветных металлов и ответственных узлов. Обеспечивает высокую точность и минимальное термическое воздействие.',
    '',
    '· РУЧНАЯ ДУГОВАЯ СВАРКА (MMA)\n' +
    'Классическая технология для монтажных и ремонтных работ, подходит для металлоконструкций, закладных элементов, наружных узлов и нестандартных объектов.',
    '',
    'НАШИ УСЛУГИ ПО СВАРОЧНЫМ РАБОТАМ:',
    '1. Изготовление металлоконструкций\n' +
    'Мы осуществляем сварку металлических конструкций любой сложности, от небольших деталей до масштабных промышленных объектов.',
    '',
    '2. Ремонт и восставновление изделий\n' +
    'Мы выполняем восстановление поврежденных метоллоизделий, устраняем трещины и другие дефекты с использованием аргоннодуговой сварки и MIG/MAG технологии.',
    '',
    '3. Сварка тонколистного металла\n' +
    'С применением TIG сварки мы обеспечиваем аккуратные и прочные соединения тонкостенных деталей без перегрева и деформации.'
];


const MECHANICAL_PROCESSING_DESCRIPTION = [
    'Механическая обработка металла с нашей компанией позволяет клиентам беспокоиться только о своих проектах, менеджеры всегда на связи, а технологи готовы оптимизировать изделия для улучшения его характеристик и времени производства.',
    '',
    'ТОКАРНАЯ ОБРАБОТКА',
    'Используя метод токарных работ, компания ООО «Характер металла» обрабатывает металлы и сплавы: сталь, чугун, титан, бронзу, медь и другие, а также различные пластмассы и текстолиты.',
    '',
    'Виды токарных работ:\n' +
    '• Торцевание\n' +
    '• Снятие фасок\n' +
    '• Нарезание наружной и внутренней резьбы\n' +
    '• Вытачивание канавок\n' +
    '• Накатывание рифлений\n' +
    '• Обработка торцов и уступов\n' +
    '• И многое другое\n',
    '',
    'ФРЕЗЕРНАЯ ОБРАБОТКА',
    'Наша компания выполняет на заказ фрезерные работы по металлу любой сложности. Принимаем заказы на фрезерную обработку деталей и изготовление готовых изделий из различных материалов: чугун, сталь, включая нержавейку, латунь, бронзу, титан, медь и алюминий.',
    'Мы работаем также с титановыми, порошковыми и супер‑сплавами, с некоторыми марками труднообрабатываемых материалов, например, с инструментальными и закалённой сталями. Возможна обработка пластика (капролон, нейлон, полиуретан).'
];

const ENGINEERING_DESCRIPTION = [
    'Разработка изделий — это комплексный инженерный процесс, включающий в себя анализ задачи, проектирование, моделирование, подбор материалов и подготовку всей необходимой документации для производства.',
    'В компании ООО «Характер металла» инжиниринг начинается с понимания функциональных требований, условий эксплуатации и технологических ограничений.',
    '',
    'На первом этапе создаётся 3D‑модель изделия — точная цифровая репрезентация будущего объекта. Моделирование проводится в профессиональных CAD‑системах, с учётом допусков, методов обработки и сборки. Это позволяет заранее выявить потенциальные проблемы, оптимизировать конструкцию под лазерную резку, гибку, сварку и другие операции. 3D‑модель служит основой для визуализации, согласования с заказчиком и подготовки производственных файлов.',
    '',
    'Следующий этап — разработка конструкторской документации. Мы оформляем полный комплект КД. Документация включает все необходимые параметры: размеры, допуски, материалы, методы обработки, требования к качеству и упаковке. При необходимости выполняется реверс‑инжиниринг — восстановление чертежей по образцу изделия или 3D‑сканированию.',
    '',
    'Инжиниринг в ООО «Характер металла» — это не просто проектирование, а интеграция идеи в реальный производственный процесс. Мы учитываем технологичность, стоимость, надёжность и эстетические требования. В результате заказчик получает готовое решение, адаптированное под серийное или индивидуальное производство.'
];

const COATING_DESCRIPTION = [
    'Компания ООО «Характер металла» предлагает услугу порошковой полимерной покраски металлических изделий. Мы используем современное оборудование и сертифицированные материалы, обеспечивая стойкое, равномерное и эстетичное покрытие для деталей любой формы и назначения.',
    '',
    'УНИКАЛЬНЫЕ СВОЙСТВА ПОРОШКОВОЙ ОКРАСКИ:\n' +
    '• надёжная защита от коррозии\n' +
    '• сохранение привлекательного внешнего вида на длительный срок\n' +
    '• повышенная устойчивость к механическим повреждениям, таким как царапины, износ и пыль\n' +
    '• возможность решения дизайнерских и архитектурных задач за счёт разнообразия цветов и декоративных эффектов\n' +
    '• защита от атмосферных осадков, ультрафиолетового излучения и температурных перепадов\n' +
    '',
    'Каждый этап — под контролем мастера, технология полностью соответствует требованиям к качеству и долговечности покрытия. Только такой подход даёт по‑настоящему профессиональный результат.'
];


export default function ServiceDetail() {
    const { slug } = useParams();
    const service = services.find(s => s.slug === slug);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [slug]);

    if (!service) {
        return <div className="not-found">Услуга не найдена</div>;
    }

    let description = [];
    let videoMP4, videoWebM;

    switch (slug) {
        case 'laser-rezka':
            description = LASER_DESCRIPTION;
            videoMP4 = laserVideoMP4;
            videoWebM = laserVideoWebM;
            break;
        case 'gibka-metalla':
            description = GIBKA_DESCRIPTION;
            videoMP4 = bendingVideoMP4;
            videoWebM = bendingVideoWebM;
            break;
        case 'svarochnye-raboty':
            description = WELDING_DESCRIPTION;
            videoMP4 = svarkaVideoMP4;
            videoWebM = svarkaVideoWebM;
            break;
        case 'meh-obrabotka':
            description = MECHANICAL_PROCESSING_DESCRIPTION;
            videoMP4 = mehObrabotkaMP4;
            videoWebM = mehObrabotkaWebM;
            break;
        case 'pokraska':
            description = COATING_DESCRIPTION;
            videoMP4 = pokraskaMP4;
            videoWebM = pokraskaWebM;
            break;
        case 'inginiring':
            description = ENGINEERING_DESCRIPTION;
            break;
        default:
            description = [service.text];
    }

    return (
        <section className="service-detail">
            <button
                onClick={() => window.history.back()}
                className="back-button"
                aria-label="Вернуться на предыдущую страницу"
            >
                ← Назад
            </button>

            <div className="service-container">
                <div className="service-header">
                    <h1>{service.title}</h1>
                </div>

                <div className="service-description">
                    {description.map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                    ))}
                </div>

                {(videoMP4 || videoWebM) && (
                    <div className="video-section">
                        <VideoWithLoader
                            mp4Src={videoMP4}
                            webmSrc={videoWebM}
                            className="service-video"
                        />
                    </div>
                )}
            </div>
        </section>
    );
}
